import { render, staticRenderFns } from "./AppContentHeader.vue?vue&type=template&id=af4abbb4&scoped=true&"
import script from "./AppContentHeader.vue?vue&type=script&lang=js&"
export * from "./AppContentHeader.vue?vue&type=script&lang=js&"
import style0 from "./AppContentHeader.vue?vue&type=style&index=0&id=af4abbb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4abbb4",
  null
  
)

export default component.exports